import { observer } from 'mobx-react';
import { useStore } from '../../state/MobxContext';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloverleafImage from '../Main/image/Cloverleaf.png';
import DialogContent from '@mui/material/DialogContent';
// import { TextField } from '@mui/material';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Grid from "@mui/material/Grid/Grid";
import { useEffect } from "react";
import UserImage from "../Main/image/User.png";
import EtherImage from "../Main/image/2089411.png"
import StandImage from "../Main/image/Icon256.png"
import { faSquarePlus } from '@fortawesome/free-solid-svg-icons';
import { faSquareMinus } from '@fortawesome/free-solid-svg-icons';


















function CloverSale() {
  const { loginStore } = useStore();
  const { SaleStore } = useStore();
  const { CoinStore } = useStore();


  // const navigate = useNavigate();

  const useStyles = makeStyles((theme) => ({
    //Dialog
    Dialog: {
      width: '450px',
      height: "auto",
      // minHeight: "25rem"
      minHeight: "auto"

    },
    DialogMobile: {
      height: 'auto',
      width: '80%',
      minWidth: "320px",
      padding: '0'
    },
    //UserImage
    UserImage: {
      width: "40px",
      height: "40px"
    },
    UserImageMobile: {
      flex: 1,
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    },
  }));


  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px)");

  // let Clover_sale_count = SaleStore?.sale_clover_Token;

  let User_Clover_Count = loginStore.CloverCount;




  let Guide_clover_dialog_CloverSale_01 = loginStore?.Guide_clover_dialog_CloverSale_01; //My.판매
  let Guide_clover_dialog_CloverSale_02 = loginStore?.Guide_clover_dialog_CloverSale_02; //구매
  let Guide_clover_allPage_03 = loginStore?.Guide_clover_allPage_03; //수수료확인


  let sale_clover_Token_count = SaleStore?.sale_clover_Token_commision; //수수료

  // let grade_error_clover_token_tranCommisions = loginStore?.grade_error_clover_token_tranCommisions; //수수료



  // useEffect(() => {// 클로버 판매계산
  //   // console.log("CloverSaleDialogStart");
  //   async function UserCloverSaleInfo() {
  //     if (loginStore?.isCloverSaleDialogOpen === true) {
  //       await SaleStore.getCloverCountKRW("CloverSaleDialog");
  //     }
  //   }
  //   UserCloverSaleInfo();
  //   // eslint-disable-next-line
  // }, [loginStore?.isCloverSaleDialogOpen])

  let Clover_sale_count = SaleStore?.sale_clover_Token;//클로버 량
  let Clover_count = SaleStore?.sale_clover_count;



  // let Clover_Token_Count_Grade_Count = this.grade_clover_Token_count;
  // let Clover_Count_Grade_Count = this.grade_clover_Token_count;

  let Grade_Clover_Count = SaleStore?.grade_clover_count;
  let Grade_Clover_Token_Count = SaleStore?.grade_clover_Token_count;


  // console.log("Grade_Clover_Count_Test", Grade_Clover_Count_Test);
  // console.log("Grade_Clover_Token_Count_Test", Grade_Clover_Token_Count_Test);



  const WhiteTextTypography = withStyles({
    root: {
      color: "#FFFFFF",
      fontSize: "1.5rem"


    }
  })(Typography);

  const CountTypographyMobile = withStyles({
    root: isMobile ?
      {
        fontSize: '0.8rem',
      }
      :
      {
        fontSize: '0.9rem',
      }
  })(Typography);

  const isCloverSaleDialogOpen = loginStore?.isCloverSaleDialogOpen;
  // let isCommissionButton = SaleStore?.isCommissionButton;


  return (
    <div>
      <Dialog classes={isMobile ? { paper: classes.DialogMobile } : { paper: classes.Dialog }} maxWidth="xl" open={isCloverSaleDialogOpen} onClose={loginStore.setDialogClose()}>
        <Box sx={isMobile ? { display: 'flex', bgcolor: 'black', width: 'auto', maxWidth: '600px', height: '60px', } : { display: 'flex', bgcolor: 'black', width: '100%', maxWidth: '600px', height: '70px', }}>
          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center' >
            <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="flex-end"  >
              <img src={CloverleafImage} width="50" height="50" alt="Cloverleaf" />
              <WhiteTextTypography > {Guide_clover_dialog_CloverSale_01}</WhiteTextTypography>
            </Grid>
            <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
              <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("CloverSaleFalse") }} />
            </Grid>
          </Grid>
        </Box>

        {/* Ui test 2 */}
        <DialogContent >

          <Box sx={{ boxShadow: 5 }} >
            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent="space-between" alignItems='center' marginBottom="1rem">

              <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                <Box sx={isMobile ? { display: 'flex', border: 2, borderColor: '#e0e0e0', width: '30px', height: '30px', margin: 1 }
                  : { display: 'flex', border: 2, borderColor: '#e0e0e0', width: '40px', height: '40px', margin: 1 }}>
                  {loginStore?.loginState?.profile_image !== null ?
                    <img className={isMobile ? classes.UserImageMobile : classes.UserImage} src={`${process.env.REACT_APP_PROFILE_IMAGE_SERVER}${loginStore?.loginState?.profile_image}`} alt="UserImage" />
                    : <img className={isMobile ? classes.BasicUserImageMobile : classes.BasicUserImage} src={UserImage} alt="UserImage" />
                  }
                </Box>
              </Grid>

              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' >
                  <Grid container item xs={5} sm={5} md={5} lg={5} xl={5} justifyContent='flex-start' alignItems='center' gap={1} >
                    <Grid container item xs={1} sm={1} md={1} justifyContent='flex-start' alignItems='center' >
                      <img style={{ width: '1.3rem', height: "auto" }} src={StandImage} alt="StandImage" />
                    </Grid>
                    <Grid container item xs={5} sm={5} md={5} justifyContent='flex-start' alignItems='flex-end'>
                      <CountTypographyMobile  >
                        {CoinStore?.StandData === undefined || null || "" ? "0" : CoinStore?.StandData}
                      </CountTypographyMobile>
                    </Grid>
                  </Grid>
                  <Grid container item xs={5} sm={5} md={5} lg={5} xl={5} justifyContent='flex-start' alignItems='center' gap={1} >
                    <Grid container item xs={1} sm={1} md={1} justifyContent='flex-start' alignItems='center'>
                      <img style={{ width: '20px', height: "20px" }} src={CloverleafImage} alt="CloverleafImage" />
                    </Grid>
                    <Grid container item xs={5} sm={5} md={5} justifyContent='flex-start' alignItems='flex-end'>
                      <CountTypographyMobile  >
                        {[loginStore?.CloverCount].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      </CountTypographyMobile>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container item xs={4} sm={4} md={4} lg={4} xl={4} fontSize={isMobile ? "2rem" : "3rem"} fontWeight='700' justifyContent='center' alignItems='center'>
                {/* {AllLevel}.LV */}
              </Grid>
            </Grid>
          </Box>

          <Box sx={isMobile ? { border: 1, borderRadius: '10px', margin: '-5px', marginTop: '0px' } : { border: 1, borderRadius: '10px', p: "1rem" }}>
            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' justifyContent='center' alignItems='center' >
              <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} paddingX="0.5rem" paddingY="0.7rem" gap={1} direction="row" justifyContent='center' alignItems="flex-end" >
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems="center" sx={{ p: 0, m: 0 }} gap={0.4} >
                  <Typography style={{ fontWeight: 'light' }} variant={isMobile ? "subtitle1" : "h5"}>{Grade_Clover_Count !== 0 ? Grade_Clover_Count : '0'}</Typography>
                  <img style={{ width: 'auto', height: "auto", maxHeight: "25px", maxWidth: "25px" }} src={CloverleafImage} alt='CloverleafImage' />
                  <FontAwesomeIcon icon={faSquarePlus} size='xl' onClick={(e) => { SaleStore.setBuyCloverCount("+") }} max={50} />
                  <FontAwesomeIcon icon={faSquareMinus} size='xl' onClick={(e) => { SaleStore.setBuyCloverCount("-") }} max={0} />
                </Grid>
              </Grid>
              <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} paddingX="0.5rem" paddingY="0.7rem" direction="row" justifyContent='center' alignItems="center">
                <img style={{ width: 'auto', height: "auto", maxHeight: "25px", maxWidth: "25px" }} src={StandImage} alt='StandImage' />
                <Typography style={{ fontWeight: 'light' }} variant={isMobile ? "subtitle1" : "h5"}>{Grade_Clover_Token_Count !== 0 ? Grade_Clover_Token_Count : '0'}</Typography>
              </Grid>
              <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} paddingX="0.5rem" paddingY="0.7rem" direction="row" justifyContent='center' alignItems="center">
                <img style={{ width: 'auto', height: "auto", maxHeight: "25px", maxWidth: "25px" }} src={EtherImage} alt='EtherImage' />
                <Typography style={{ fontWeight: 'light' }} variant={isMobile ? "subtitle1" : "h5"}>{sale_clover_Token_count !== 0 ? sale_clover_Token_count : '0'}</Typography>
              </Grid>
            </Grid>
            {/* {
              isCommissionButton === true ?
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='flex-end' marginTop='25px'>
                  <Button variant="contained" size="medium"
                    style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 25 }
                      : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 25 }} onClick={(e) => { SaleStore.getCloverTokenSend("CloverSale"); }} >{Guide_clover_dialog_CloverSale_02}</Button>
                </Grid>
                :
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='flex-end' marginTop='25px'>
                <Button variant="contained" size="medium"
                  style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 25 }
                    : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 25 }} onClick={(e) => { SaleStore.getCloverTokenTranCommisions("Button"); }} >{Guide_clover_allPage_03}</Button>
              </Grid>
            } */}
            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='flex-end' marginTop='25px'>
              <Button variant="contained" size="medium"
                style={isMobile ? { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 25 }
                  // : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 25 }} onClick={(e) => { SaleStore.getCloverTokenSend("CloverSale"); }} >{Guide_clover_dialog_CloverSale_02}</Button>
                  : { maxWidth: '100%', maxHeight: '100%', minWidth: '100%', minHeight: '100%', fontSize: 25 }} onClick={(e) => { SaleStore.TokenToCloverExchange(); }} >{Guide_clover_dialog_CloverSale_02}</Button>
            </Grid>
          </Box>
        </DialogContent>
        {/* Ui test 2 */}


      </Dialog>
    </div>
  );
};

export default observer(CloverSale);